import React from "react";
import { Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { selectSelectedTeam } from "../../../features/clubhouse/clubhouseSlice";
import { selectSetting } from "../../../features/global/globalSlice";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { Breakpoint } from "../../../hooks/useBreakpoint";
import { AUTH_LEVELS } from "../../../lib/globals";

const ClubhouseSidebar = ({
    breakpoint,
    toggleNavbar,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
}): React.JSX.Element => {
    const selectedTeam = useAppSelector(selectSelectedTeam);
    const currentYear = parseInt(
        useAppSelector(state =>
            selectSetting(state, "majorybl_current_league_year"),
        )?.setting,
    );
    const { user } = useAppSelector(state => state.auth);
    const routePrefix = `/coachs-clubhouse/team/${selectedTeam?.id}`;
    let setting = useAppSelector(state =>
        selectSetting(state, "majorybl_display_placement_link"),
    );
    const displayPlacement = Boolean(setting?.setting === "true" ? 1 : 0);

    setting = useAppSelector(state =>
        selectSetting(state, "majorybl_display_resume_link"),
    );
    const displayResume = Boolean(setting?.setting === "true" ? 1 : 0);
    const currentTeamsLeague = selectedTeam?.leagues?.find(
        l => l.year === currentYear,
    );

    return (
        <Stack gap={2}>
            <Link
                to={`${routePrefix}`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Team Home
            </Link>
            {currentTeamsLeague && (
                <>
                    <Link
                        to={`${routePrefix}/league-info`}
                        className="btn btn-primary"
                        onClick={toggleNavbar}
                    >
                        Opp. Team's Info
                    </Link>
                    <Link
                        to={`${routePrefix}/schedule`}
                        className="btn btn-primary"
                        onClick={toggleNavbar}
                    >
                        Team Schedule
                    </Link>
                    <Link
                        to={`${routePrefix}/league/${currentTeamsLeague?.id}`}
                        className="btn btn-primary"
                        onClick={toggleNavbar}
                    >
                        League Standings
                    </Link>
                    <Link
                        to={`${routePrefix}/league/${currentTeamsLeague?.id}/schedule`}
                        className="btn btn-primary"
                        onClick={toggleNavbar}
                    >
                        League Schedule
                    </Link>
                    <Link
                        to={`${routePrefix}/league/${currentTeamsLeague?.id}/playoffs`}
                        className="btn btn-primary"
                        onClick={toggleNavbar}
                    >
                        League Playoff Bracket
                    </Link>
                </>
            )}
            <Link
                to={`${routePrefix}/roster`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Roster
            </Link>
            <Link
                to={`${routePrefix}/coi`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Cert. of Insurance
            </Link>
            <Link
                to={`${routePrefix}/policy-procedures`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Policy & Procedures
            </Link>
            <Link
                to={`/coachs-clubhouse/rules`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                League Rules
            </Link>
            <Link
                to={`${routePrefix}/tryouts`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Tryout Info
            </Link>
            <Link
                to={`${routePrefix}/looking-for-players`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Looking for Players
            </Link>
            {(selectedTeam?.settings?.showResumeToCoach ||
                (displayResume &&
                    !selectedTeam?.settings?.hideResumeFromCoach)) && (
                <Link
                    to={`${routePrefix}/resume`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Team Resume
                </Link>
            )}
            {displayPlacement && (
                <Link
                    to={`${routePrefix}/placement`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Team Placement
                </Link>
            )}
            {user && AUTH_LEVELS.leaguemanagement.includes(user.userLevel) && (
                <Link
                    to={`${routePrefix}/ratings`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Team Ratings
                </Link>
            )}
        </Stack>
    );
};

export default ClubhouseSidebar;
